import momentTypesData from "./momentTypes";
import locationsData from "./locations";
import partiesData from "./parties";
import emotionsData from "./emotions";
import behavioursData from "./behaviour";
import subscriptionsData from "./subscriptions";

class Repository {
  constructor(objList, sortOnProperty, sortAsc) {
    this.objList = objList;
    this.sortOnProperty = sortOnProperty || "name";
    this.sortAsc = sortAsc !== false;
    window.console.log("Creating repository");
  }

  getById(id) {
    return this.objList.find(i => i.id === id);
  }

  getAll(locale) {
    if (this.sortOnProperty) {
      return this.objList.sort((a, b) => this.dynamicSort(a, b, locale));
    }
    return this.objList;
  }

  dynamicSort(obj1, obj2, langLocale) {
    let a = obj1;
    let b = obj2;

    if ((!a && !b) || a === b) {
      return 0;
    } else if (!a) {
      return this.sortAsc ? 1 : -1;
    } else if (!b) {
      return this.sortAsc ? -1 : 1;
    }
    // eslint-disable-next-line no-prototype-builtins
    if (a.hasOwnProperty(this.sortOnProperty) && b.hasOwnProperty(this.sortOnProperty)) {
      a = a[this.sortOnProperty];
      b = b[this.sortOnProperty];
      const locale = langLocale || "nl";
      // eslint-disable-next-line no-prototype-builtins
      if (a.hasOwnProperty(locale)) {
        a = a[locale];
      }
      // eslint-disable-next-line no-prototype-builtins
      if (b.hasOwnProperty(locale)) {
        b = b[locale];
      }
    }

    if (a < b) {
      return this.sortAsc ? -1 : 1;
    } else if (a > b) {
      return this.sortAsc ? 1 : -1;
    }
    return 0;
  }
}

export const momentTypeRepository = new Repository(momentTypesData, "start");
export const locationRepository = new Repository(locationsData);
export const partyRepository = new Repository(partiesData);
export const emotionRepository = new Repository(emotionsData);
export const behaviourRepository = new Repository(behavioursData);
export const subscriptionRepository = new Repository(subscriptionsData);
